import { cx } from '@libs/classnames';
import { Button } from '@ui/components/Button';

import styles from './TournamentSponsor.module.css';

type Props = {
  className?: string;
  logoUrl?: string | null;
  description?: string | null;
  linkHref?: string | null;
};

export function TournamentSponsor({ className, logoUrl, description, linkHref }: Props) {
  if (!logoUrl && !description && !linkHref) return null;

  return (
    <div className={cx(styles.sponsor, className)}>
      <div className={styles.title}>Спонсор</div>

      <div
        className={cx(styles.content, {
          [styles.logoOnly]: logoUrl && !description && !linkHref,
        })}
      >
        {logoUrl && (
          <div className={styles.logoWrapper}>
            <img className={styles.logo} src={logoUrl} />
          </div>
        )}

        {(description || linkHref) && (
          <div className={styles.descriptionAndLink}>
            {description && <div className={styles.description}>{description}</div>}

            {linkHref && (
              <a className={styles.sponsorLink} href={linkHref}>
                <Button variant="slim">Подробнее ›</Button>
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
